import { Component, EventEmitter, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-delete-fax-modal",
  templateUrl: "./delete-fax-modal.component.html",
  styleUrls: ["./delete-fax-modal.component.scss"],
})
export class DeleteFaxModalComponent {
  @Output() close = new EventEmitter();
  @Output() submit = new EventEmitter();

  constructor(private readonly _modalService: ModalService) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.DeleteFax;
  }

  onClose() {
    this._modalService.closeModal();
    this.close.emit();
  }

  onSubmit() {
    this._modalService.closeModal();
    this.submit.emit();
  }
}
